/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import { CultureID } from './CultureID';
import LocalActionBase from './LocalActionBase';
import LocalAtlasData from './LocalAtlasData';

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

/** [[Local]] handler for cc.Sprite's to respond to Localization setting changes. */
@cc._decorator.ccclass
export default class LocalAtlasComponent extends LocalActionBase
{
    @property([LocalAtlasData])
    protected atlasInfos: LocalAtlasData[] = [new LocalAtlasData()];

    protected nodeSpriteInfoMap: Map<cc.Node, ISpriteFrameInfo> = new Map();
    protected cultureAtlasMap: Map<CultureID, cc.SpriteAtlas> = new Map();

    private _isChanged: boolean = false;

    /** @hidden */
    protected start(): void
    {
        super.start();

        if (this.nodeCollection.HasValue())
        {
            this.nodeCollection.Value.Nodes.forEach(node =>
                {
                    const sprite: cc.Sprite = node.getComponent(cc.Sprite);
                    if (!sprite) { return; }

                    this.nodeSpriteInfoMap.set(node, { Sprite: sprite, Frame: sprite.spriteFrame });
                });
        }

        this.atlasInfos.forEach(atlasInfo =>
            {
                this.cultureAtlasMap.set(atlasInfo.CultureId, atlasInfo.Atlas);
            });
    }

    /** @hidden */
    protected onCultureChanged(cultureId: CultureID): void
    {
        const atlas: cc.SpriteAtlas = this.cultureAtlasMap.get(cultureId);
        if (!atlas)
        {
            this.reset();
            return;
        }

        this._isChanged = true;
        this.nodeCollection.Value.Nodes.forEach(node =>
            {
                const spriteInfo: ISpriteFrameInfo = this.nodeSpriteInfoMap.get(node);
                const newFrame: cc.SpriteFrame = atlas.getSpriteFrame(spriteInfo.Sprite.spriteFrame.name);
                if (!newFrame) { return; }

                spriteInfo.Sprite.spriteFrame = newFrame;
            });
    }

    /** Sets sprite frame texture back to default. */
    protected reset(): void
    {
        if (!this._isChanged || !this.nodeCollection.HasValue()) { return; }

        this.nodeCollection.Value.Nodes.forEach(node =>
            {
                const spriteInfo: ISpriteFrameInfo = this.nodeSpriteInfoMap.get(node);
                spriteInfo.Sprite.spriteFrame = spriteInfo.Frame;
            });

        this._isChanged = false;
    }
}

interface ISpriteFrameInfo
{
    Sprite: cc.Sprite;
    Frame: cc.SpriteFrame;
}
